import { Radio, RadioGroup } from '@mui/material';
import { useMemo } from 'react';
import ThumbsIcon from './ThumbsIcon';
import styles from './ThumbSelector.module.scss';

const ThumbSelector = ({
  thumbsUp,
  onChange,
}: {
  thumbsUp?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  const thumbsUpIcon = useMemo(() => <ThumbsIcon selected={thumbsUp} direction="up" />, [thumbsUp]);
  const thumbsDownIcon = useMemo(
    () => <ThumbsIcon selected={thumbsUp === undefined ? undefined : !thumbsUp} direction="down" />,
    [thumbsUp],
  );

  return (
    <RadioGroup
      className={styles.thumbsUpRadioGroup}
      onChange={onChange}
      data-testid="thumbs-input"
    >
      <Radio
        value="yes"
        icon={thumbsUpIcon}
        checkedIcon={thumbsUpIcon}
        disableFocusRipple
        disableRipple
        disableTouchRipple
        data-testid="thumbs-up-option"
        checked={thumbsUp === true}
      />
      <Radio
        value="no"
        icon={thumbsDownIcon}
        checkedIcon={thumbsDownIcon}
        disableFocusRipple
        disableRipple
        disableTouchRipple
        data-testid="thumbs-down-option"
        checked={thumbsUp === false}
      />
    </RadioGroup>
  );
};

export default ThumbSelector;
